import React from "react";
import {
  CardHeader,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { LoadingButton } from "@mui/lab";

const ShowMoreText = ({ lines, more, less, className, expanded: initialExpanded, children }) => {
  const [expanded, setExpanded] = React.useState(initialExpanded || false);
  return (
    <div className={className}>
      <div style={!expanded ? { overflow: "hidden", display: "-webkit-box", WebkitLineClamp: lines || 1, WebkitBoxOrient: "vertical" } : {}}>
        {children}
      </div>
      <span
        style={{ color: "#1976d2", cursor: "pointer", fontSize: "13px" }}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? less : more}
      </span>
    </div>
  );
};

const JobApplicationProcess = (props) => {
  const {
    shopWebsiteConfig,
    handleChange,
    handleSave,
    handleRestore,
    loadingButton,
  } = props?.shopWebsiteCustomization;
  const data = shopWebsiteConfig?.JobApplication;
  return (
    <Card className="bg-white shadow-sm">
      <CardHeader
        title={
          <div className="text-[#24211F] text-base font-bold">
            Select Job Application Process (Join the Team link on the site)
          </div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc", fontSize: "14px" }}>
        <CardContent>
          <ShowMoreText
            lines={1}
            more="View more"
            less="View less"
            className="show-hide-description"
            expanded={false}
            children={
              <p className="text-justify">
                <b>Disclaimer:</b> Rita's Franchise Company and its affiliates
                are not the employer and do not control the terms and conditions
                of employment. Neither Rita's Franchise Company nor its
                affiliates will be participating in the hiring process. We offer
                these application options as a service to our franchisee but
                have no participation in how they are carried out. Therefore RFC
                urges the franchisee to consult with their own attorney in
                developing their own employment program. Remember, franchisees
                are responsible for establishing and implementing your own
                employment practices and procedures.
              </p>
            }
          ></ShowMoreText>
          <div>
            <RadioGroup
              row={false}
              name="intRitasJob"
              id="intRitasJob"
              value={data?.intRitasJob?.toString()}
              aria-labelledby="demo-row-radio-buttons-group-label"
              onChange={(e) =>
                handleChange(
                  "JobApplication",
                  "intRitasJob",
                  parseInt(e.target.value)
                )
              }
            >
              <FormControlLabel
                value={"1"}
                control={
                  <Radio size="small" sx={{ alignSelf: "self-start" }} />
                }
                label={
                  <span style={{ fontSize: "14px" }}>
                    <ShowMoreText
                      lines={1}
                      more="View more"
                      less="View less"
                      className="show-hide-description"
                      expanded={false}
                      children={
                        <p className="text-justify">
                          <b>Ritasjobs.com</b> - Ritas has partnered with
                          NinjaGig.com to create Ritasjobs.com, which is an
                          Online Application / Recruitment website for stores to
                          create and utilize. The cost is $20 per month or $200
                          a year, there is no contract, and you can cancel
                          anytime. To view a demo about Ritasjobs or to sign up,
                          go to:{" "}
                          <a
                            href="https://www.ritasjobs.com/signup/"
                            target="newtab"
                          >
                            {" "}
                            https://www.ritasjobs.com/signup/{" "}
                          </a>
                          . You can also view a sample of what the recruitment
                          website will look like at{" "}
                          <a
                            href="https://custard.ritasjobs.com/"
                            target="newtab"
                          >
                            {" "}
                            https://custard.ritasjobs.com/
                          </a>
                          

                          *Multi-Unit Operators can create one primary store
                          account that is used for multiple locations. Where
                          youwill still need to use the employment webpage of
                          yourprimary account, you will be able to create
                          multipleoptions for a Treat Team Member to select
                          whenchoosing which job they are looking to apply for.
                          Forexample, you would create job descriptions for
                          TreatTeam Member - Cool University and Treat Team
                          Member -Trevose location. To connect this primary
                          account toyour other locations "join the team" link of
                          theirCoolNet websites, please send a feedback via
                          theCoolNet Homepage
                        </p>
                      }
                    ></ShowMoreText>
                  </span>
                }
                className="intRitasJob"
              />
              <FormControlLabel
                value={"2"}
                control={
                  <Radio size="small" sx={{ alignSelf: "self-start" }} />
                }
                label={
                  <span style={{ fontSize: "14px" }}>
                    <ShowMoreText
                      lines={1}
                      more="View more"
                      less="View less"
                      className="show-hide-description"
                      expanded={false}
                      children={
                        <p className="text-justify">
                          <b>CoolNet Generic Job Application Form </b> - There
                          is no cost for this option. This option will takeusers
                          to the employment interest page of the Coolnetwhere
                          they can download, save and complete theapplication.
                          Please note: END USERS MUST SAVE THE DOCFIRST before
                          filling it in, or Franchisees may receiveblank
                          employment interest forms. This is an issue withhow
                          browsers and Adobe handle the forms for
                          privacyreasons. Also, this form is generic and it
                          isimportant to determine what items are needed
                          toconform to local, state and federal laws. PLEASE
                          NOTE:The completed form will be emailed back to the
                          personlisted in Store Profiler as the contact: In this
                          casethe forms would be sent to:
                        </p>
                      }
                    ></ShowMoreText>
                  </span>
                }
                className="intRitasJob"
              />
              <FormControlLabel
                value={"3"}
                sx={{ paddingTop: "0px" }}
                control={
                  <Radio size="small" sx={{ alignSelf: "self-start" }} />
                }
                label={
                  <div style={{ fontSize: "14px" }}>
                    <ShowMoreText
                      lines={1}
                      more="View more"
                      less="View less"
                      className="show-hide-description"
                      expanded={false}
                      children={
                        <p className="text-justify">
                          <b>Third Party Application Website</b> - Website - if
                          you use another application please enter the
                          websitehere and the Join the team link on your
                          store'swebsite will take potential candidates to
                          thatapplication page. For example
                        </p>
                      }
                    ></ShowMoreText>
                    <p className="text-justify">
                      <b>NOTE:</b> RFC will ONLY forward users to the site
                      below. RFC assumes no responsibility for the forwarded
                      sites contentor functionality.
                    </p>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={data?.vchthirdPartyURL}
                      name="headline"
                      id="headline"
                      disabled={
                        data?.intRitasJob !== 3 && data?.intRitasJob !== "3"
                      }
                      onChange={(e) =>
                        handleChange(
                          "JobApplication",
                          "vchthirdPartyURL",
                          e.target.value
                        )
                      }
                    />
                    <i>{`Ex: https://www.jobsrus.com`}</i>
                  </div>
                }
                className="intRitasJob"
              />
              <FormControlLabel
                value={"4"}
                control={
                  <Radio size="small" sx={{ alignSelf: "self-start" }} />
                }
                label={
                  <div style={{ fontSize: "14px" }}>
                    <ShowMoreText
                      lines={1}
                      more="View more"
                      less="View less"
                      className="show-hide-description"
                      expanded={false}
                      children={
                        <p className="text-justify">
                          <b>NO JOIN THE LINK</b> - If you select this option
                          the "Join the Team" Link will not be displayed on your
                          website. This is the default.
                        </p>
                      }
                    ></ShowMoreText>
                  </div>
                }
                className="intRitasJob"
              />
            </RadioGroup>
          </div>
          <p>
            <b>NOTE:</b>
            By selecting Yes to use any of the options above you are
            acknowledging that you have read this message and understand that
            Ritas Franchisee Company is not participating in the employment
            process of the store.
          </p>
        </CardContent>
      </div>
      <CardActions
        sx={{ backgroundColor: "#FFF8F8", borderTop: "1px solid #C12637",height:'50px' }}
      >
        <Grid container>
          <Grid item xs={6}>
            <Button
              className="text-[#24211F] font-semibold"
              onClick={() => handleRestore("JobApplication")}
            >
              Restore
            </Button>
          </Grid>
          <Grid item xs={6} container justifyContent={{ xs: "right" }}>
            <LoadingButton
              variant="outlined"
              disabled={loadingButton === "JobApplication" ? true : false}
              loading={loadingButton === "JobApplication" ? true : false}
              onClick={() => handleSave("JobApplication")}
              className="text-[#C12637] font-semibold bg-white border-[#C12637]"
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default JobApplicationProcess;